import displayFloodZoneInfo from "../../SummaryTools/displayFloodZoneInfo.js";
import getFloodZoneInfo from "../../SummaryTools/getFloodZoneInfo.js";
import getParcelInfo from "../../SummaryTools/getParcelInfo.js";
import initializeMap from "../../SummaryTools/initializeMap.js";
import { zoomToGeometry } from "../../SummaryTools/initializeMap.js";
import MapToImage from "../../SummaryTools/ToImage.js";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import areLayersLoaded from "../../../util/areLayersLoaded.js";
import { setLoaders } from "../../../UI/summaryModal.js";


export class ParcelSummary {
    // Private Fields
    #summaryMap = {
        map: null,
        view: null
    };
    parcelService;
    #basemapService;
    #mapImage;
    
    // Public Fields
    parcelInfo;
    pin;
    originalGeometry; 
    //the geometry that is queried
    geometry;
    optOut; 


    summaryErrors = document.createElement('div'); 

    // Summary Elements
    summaryDivs = {
        floodZoneInfo: document.createElement('div'),
        basicParcelInfo: document.createElement('div')
    };

    constructor(pin, parcelService, basemapService) {
        if (new.target === ParcelSummary) {
            throw new Error("Abstract classes can't be instantiated.");
        }

        this.pin = pin;
        this.parcelService = parcelService;
        this.#basemapService = basemapService;
        setLoaders(this);

    }

    async #initializeMap() {
        [this.#summaryMap.map, this.#summaryMap.view] = await initializeMap(this.#basemapService, this.parcelService, this.originalGeometry.extent.center);
    }

    async #fetchParcelInfo() {
        const parcelQueryUrl = `${this.parcelService}/1`;
        this.parcelInfo = await getParcelInfo(parcelQueryUrl, this.pin);
        const parcel = this.parcelInfo.features[0];
        
        if (parcel?.attributes?.OptOut == "Y")
        {
            this.optOut = true; 
        }
        else {
            this.originalGeometry = parcel.geometry; 
            this.geometry = await geometryEngine.buffer(parcel.geometry, -10, "feet");
            return; 
        }
    }

    async #updateMapImage() {
        await areLayersLoaded(this.#summaryMap.map);
        await zoomToGeometry(this.#summaryMap.view, this.originalGeometry);
        const mapImage = await MapToImage(this.#summaryMap.map, this.#summaryMap.view);
        const newMap = document.createElement('div');
        newMap.id = "summaryMap";
        newMap.innerHTML = `<img id='summaryImage' class='w-100' src='${mapImage.dataUrl}'>`;

        const map = document.getElementById("summaryMap");
        map.replaceWith(newMap);

        this.#mapImage = null;
        this.#summaryMap.map.destroy();
        this.#summaryMap.view.destroy();

    }

    async #fetchFloodZoneInfo() {
        try {
            this.summaryDivs.floodZoneInfo.style.order = "10";
            if (this.geometry) {
                const floodData = await getFloodZoneInfo(this.geometry);
                this.summaryDivs.floodZoneInfo.innerHTML = displayFloodZoneInfo(floodData);
   
            }
        } catch (error) {
            console.error("Failed to fetch flood zone info:", error);
            this.summaryDivs.floodZoneInfo.innerHTML = "<h3>Flood Hazard Zones</h3><p>Unable to load flood zone information. Please refresh the page. If the issue persists, contact the WinGIS team.</p>";
        }
    }

    async #makeMapImage() {
        return new Promise(async (resolve, reject) => {
            try {
                await this.#fetchParcelInfo();
    
            } catch (error) {
                console.error("Error in fetching parcel info:", error);
            }
            if (this.optOut)
            {
                resolve(); 
            }

            try {
                await this.#initializeMap();
    
            } catch (error) {
                console.error("Error in map initialization:", error);
            }
    
            try {
                await this.#updateMapImage();
    
            } catch (error) {
                console.error("Error in updating map image:", error);
            }
            resolve();
        })

    }

    async basicInit() {
 
        await this.#makeMapImage(); 
        if (this.optOut)
        {
            console.error("Summary Initialized for optout parcel");
            for (const [key, value] of Object.entries(this.summaryDivs)) {
                value.innerHTML = null; 
              }
            this.summaryDivs.basicParcelInfo.innerHTML = "<span>This parcel has opted out of WinGIS services.</span>"
            throw new Error("Parcel is opted out.");
        }
        else {

            try {
                this.#fetchFloodZoneInfo();
            } catch (error) {
                console.error("Error in fetching flood zone info:", error);
            }
        }



    }
    
    displaySummary() {

        let shareButton = document.getElementById("shareSummary");
    
        let shareListener = shareButton.addEventListener("click", () => {
            let summaryTitle = document.getElementById("summaryTitle");
            let displayTitle = summaryTitle.firstChild.innerText; 

            let text = window.location.origin + window.location.pathname + "?summary=" + this.pin + "&type=" + this.constructor.name;
       
                if (navigator.clipboard) {
                  navigator.clipboard.writeText(text)
                } else {
                    alert(text);
                }
              
        }); 
        const summaryDiv = document.getElementById("summaryModalContent");
        summaryDiv.innerHTML = "";

        const fragment = document.createDocumentFragment();
        fragment.appendChild(this.summaryErrors); 

        for (const [key, div] of Object.entries(this.summaryDivs)) {
            div.id = key; 
            div.classList.add('w-100');
            fragment.appendChild(div);
          }
          

        summaryDiv.appendChild(fragment);
    }


}
